import React, {useEffect} from "react";
import {DatePicker, Divider, Form, Input, InputNumber, Select} from "antd";
import FileUploadCell from "./FileUploadCell";
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import {Constants} from "../../utils/ConstantsUtils";

const AutoForm = ({
                      formStruct, selectOptions = {}, initValues = {}, initFiles = {},
                      onFormChange, onFileChange
                  }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(initValues)
    }, [initValues]);

    const validateMessages = {
        required: "这是必选字段",
    }

    const handleValueChange = (changed, all) => {
        onFormChange && onFormChange(changed, all)
    }

    const handleFileChange = (key, files) => {
        onFileChange && onFileChange(key, files)
    }

    const renderFormItem = (item) => {
        switch (item.type) {
            case "input" :
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <Input placeholder={item.placeholder}/>
                </Form.Item>

            case "password" :
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <Input.Password placeholder={item.placeholder}/>
                </Form.Item>

            case "number" :
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <InputNumber/>
                </Form.Item>

            case "text" :
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <Input.TextArea showCount maxLength={item.maxLength ?? 10000}/>
                </Form.Item>

            case "date" :
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <DatePicker locale={locale}/>
                </Form.Item>

            case "select":
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <Select showSearch={item.search ?? true} placeholder={item.placeholder}
                            filterOption={(input, option) =>
                                (option.children + option.value).toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                        {
                            (selectOptions[item.key] ?? [])
                                .map(o => <Select.Option key={item.key + o.value}
                                                         value={o.value}>{o.name}</Select.Option>)
                        }
                    </Select>
                </Form.Item>

            case "gender":
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <Select showSearch={item.search ?? true} placeholder={item.placeholder}
                            filterOption={(input, option) =>
                                (option.children + option.value).toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                        {
                            Constants.genders.map(o => <Select.Option key={item.key + o.value}
                                                                      value={o.value}>{o.name}</Select.Option>)
                        }
                    </Select>
                </Form.Item>

            case "img" :
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <FileUploadCell
                        isPicture={true}
                        maxCount={item.maxCount ?? 1}
                        accept={'image/*'}
                        defaultFileList={initFiles[item.key] ?? []}
                        onFileChange={file => handleFileChange(item.key, file)}
                    />
                </Form.Item>
            case "file":
                return <Form.Item key={item.key} label={item.name} name={item.key} extra={item.extra}
                                  rules={[{required: item.required ?? false}]}>
                    <FileUploadCell
                        isPicture={true}
                        maxCount={item.maxCount ?? 1}
                        defaultFileList={initFiles[item.key] ?? []}
                        onFileChange={file => handleFileChange(item.key, file)}
                    />
                </Form.Item>

            case "div" :
                return <Divider dashed/>

            default:
                return <></>
        }
    }

    return (
        <>
            <Form
                validateMessages={validateMessages}
                form={form}
                labelCol={{span: 6}}
                wrapperCol={{span: 14}}
                onValuesChange={handleValueChange}
            >
                {
                    formStruct.map(row => renderFormItem(row))
                }
            </Form>
        </>
    )
}

export default AutoForm